export enum AddressTypeEnum {
    Residential = 'R',
    Mailing = 'M'
}
